import { Stack, Typography } from "@mui/material";
import { EMPTY_VALUE_PLACEHOLDER } from "@shared";
import _ from "lodash";

interface Props {
  label: string;
  value: string | null | undefined;
}

export function ReadOnlyField({ label, value }: Props) {
  const hasValue = !_.isNil(value) && value.trim().length > 0;

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1" color={hasValue ? "text.primary" : "text.secondary"}>
        {hasValue ? value : EMPTY_VALUE_PLACEHOLDER}
      </Typography>
    </Stack>
  );
}
